module.exports = import("https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js");;